/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import useResetPasswordFields from '../../components/forms/useResetPasswordFields'
import Field from '../field'

const ResetPasswordFields = ({form, prefix = 'reset-pass_', isFirstInputFocus = false}) => {
    const fields = useResetPasswordFields({form, prefix})
    const emailRef = useRef()

    useEffect(() => {
        if (isFirstInputFocus && emailRef.current) {
            emailRef.current.focus()
        }
    }, [])

    return <Field {...fields.email} inputRef={emailRef} />
}

ResetPasswordFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string,

    /** Determines if the first input should be focused */
    isFirstInputFocus: PropTypes.bool
}

export default ResetPasswordFields
